export default "__VITE_ASSET__dcf46a81__"